module.exports = __webpack_public_path__ + "static/media/TITAN-ETH.949dfcb0.png";